import classNames from 'classnames/bind'
import { useRouter } from 'next/router'
import React, { useContext } from 'react'
import { useTranslate } from 'react-polyglot'

import Select from '~/components/Form/Select'

import { useGlobalData } from '~/providers/GlobalDataProvider'
import { useStyle } from '~/providers/StyleProvider'

import useLocale from '~/hooks/useLocale'

import linkResolver from '~/utils/link-resolver'

import { Language } from '~/data/page-data/meta'

import css from './styles.module.scss'

const cx = classNames.bind(css)

interface LangSwitcherProps {
  className?: string
  alternateLangs: Language[]
  textPreset?: 'text-paragraph' | 'cta-label' | 'cta-label-small'
}

/**
 * Lang switcher component
 * @param props
 * @returns Component
 */
function LangSwitcher({
  className,
  alternateLangs,
  textPreset = 'text-paragraph',
}: LangSwitcherProps) {
  const locale = useLocale()
  const router = useRouter()
  const t = useTranslate()
  const { global } = useGlobalData()

  const onSwitchLanguage = (e) => {
    const lang = e.currentTarget.value
    const selectedLang = alternateLangs?.find((altLng) => altLng?.lang === lang)
    window.location.href = selectedLang?.url ?? `/${lang}`
  }

  const locales = router?.locales
  const options = locales?.map((lang) => ({
    value: lang,
    label: t(`langage.${lang?.toLocaleLowerCase()}`),
  }))

  return global?.asLangSwitcher ? (
    <div className={cx(className, css.LangSwitcher)}>
      <Select
        textPreset={textPreset}
        onChange={onSwitchLanguage}
        defaultValue={locale}
        options={options}
      />
    </div>
  ) : null
}

export default LangSwitcher
